import { AlertTriangle } from 'lucide-react';

import { Card } from '@/components/ui/Card';
import { describeCsError } from './csError';

/**
 * Shared loading / error / access states for the CS pages (Phase 16).
 * Mirrors the spinner + danger-card patterns used across training/eos.
 */

/** Shared form-control classes (match the eos SELECT_CLS convention). */
export const SELECT_CLS =
  'rounded-kw-md border border-kw-border bg-white px-2.5 py-1.5 text-[13px] text-kw-shark focus:border-kw-cerulean focus:outline-none focus:ring-2 focus:ring-kw-cerulean/20';

export const TEXTAREA_CLS =
  'w-full rounded-kw-md border border-kw-border bg-white px-3.5 py-2.5 text-[14px] text-kw-shark placeholder:text-kw-muted focus:border-kw-cerulean focus:outline-none focus:ring-2 focus:ring-kw-cerulean/20';

export function CsLoading() {
  return (
    <div className="flex justify-center py-16">
      <div className="size-8 animate-spin rounded-full border-2 border-kw-cerulean border-t-transparent" />
    </div>
  );
}

export function CsErrorCard({ title, error, fallback }: { title: string; error: unknown; fallback: string }) {
  return (
    <Card className="flex items-start gap-3 border-kw-danger-text/30 bg-kw-danger-bg p-4">
      <AlertTriangle className="size-5 shrink-0 text-kw-danger-text" />
      <div>
        <p className="text-[14px] font-medium text-kw-danger-text">{title}</p>
        <p className="mt-1 text-[13px] text-kw-danger-text/80">{describeCsError(error, fallback)}</p>
      </div>
    </Card>
  );
}

export function CsAccessDenied({ label }: { label: string }) {
  return (
    <div className="mx-auto max-w-2xl">
      <Card className="flex items-start gap-3 p-4">
        <AlertTriangle className="size-5 shrink-0 text-kw-warning-text" />
        <div>
          <p className="text-[14px] font-medium text-kw-shark">Access required</p>
          <p className="mt-1 text-[13px] text-kw-muted">{label}</p>
        </div>
      </Card>
    </div>
  );
}

/** Inline mutation-error strip for dialogs/forms. */
export function CsInlineError({ error, fallback }: { error: unknown; fallback: string }) {
  if (!error) return null;
  return (
    <div className="flex items-start gap-2 rounded-kw-md border border-kw-danger-text/30 bg-kw-danger-bg p-3">
      <AlertTriangle className="mt-0.5 size-4 shrink-0 text-kw-danger-text" />
      <p className="text-[12px] text-kw-danger-text">{describeCsError(error, fallback)}</p>
    </div>
  );
}
